import { AccountConnectionStatus, AccountScope, AccountType, IEnrichedAccountModel, ReferenceTypes } from "@cosine/types/api-models";
import { faker } from "@faker-js/faker/locale/en_US";

export function createEnrichedFinancialAccount (overrides: Partial<IEnrichedAccountModel> = {}): IEnrichedAccountModel {
  return {
    Type: AccountType.Checking,
    EraUserId: faker.string.uuid(),
    EraAccountId: faker.string.uuid(),
    Balance: faker.number.int({
      min: 1,
      max: 100_000_00,
    }),
    Balances: [],
    Scope: AccountScope.Normal,
    DisplayName: "Mortgage",
    InstitutionName: "MX Bank",
    SyncedAt: faker.date.anytime().toISOString(),
    Nickname: "1234",
    OverallNicknameAssignments: [],
    SourceReferences: [
      {
        ReferenceType: ReferenceTypes.MxAccountProjection,
        Value: faker.string.uuid(),
      },
    ],
    ConnectionStatus: AccountConnectionStatus.Connected,
    // @ts-expect-error: this is expecting a type we can’t / shouldn’t satisfy
    // but this comment also hides any other TS errors, which is not ideal
    SyncedAtWithSources: {},
    ...overrides,
  };
}

export function createSnaptradeAccount (overrides: Partial<IEnrichedAccountModel> = {}): IEnrichedAccountModel {
  return createEnrichedFinancialAccount({
    Type: AccountType.Investment,
    EraUserId: faker.string.uuid(),
    EraAccountId: faker.string.uuid(),
    Scope: AccountScope.Normal,
    DisplayName: "Brokerage",
    InstitutionName: "Alpaca",
    SourceReferences: [
      {
        ReferenceType: ReferenceTypes.SnapTradeAccountProjection,
        Value: faker.string.uuid(),
      },
    ],
    ...overrides,
  });
}
